import aemClientService from '@/services/aem/aemClientService';

let content;

export const initContent = async (marketName, languageCode, newContent) => {
    content = newContent || (await aemClientService.initMarketContent(marketName, languageCode));
};

export const getContent = () => content || {};
